import { types } from "./types"

export const setMapDetails = ({payload, callback}) => dispatch => {
    console.log("SET_MAP_DETAILS")
    dispatch({type: types.SET_XEMD_DETAILS.SUCCESS, payload});
    callback();
}
export const clearMapDetails = (payload) => dispatch => {
    dispatch({type: types.CLEAR_XEMD_DETAILS.SUCCESS})
}

export const setActiveFormId = payload => dispatch => {
    dispatch({ type: types.SET_ACTIVE_FORM_ID , payload });
  };